import { render, staticRenderFns } from "./AccrualsHistoryItem.vue?vue&type=template&id=85dde280&scoped=true"
import script from "./AccrualsHistoryItem.vue?vue&type=script&lang=js"
export * from "./AccrualsHistoryItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85dde280",
  null
  
)

export default component.exports